"use strict";

var PropTypes = require("prop-types");

var SponsorshipHelper = require("../sponsorshipComponents/SponsorshipHelper");
var ActionsHelper = require("../actions/ActionsHelper");

var SimpleDropdownFromWizard = require("../commonComponents/SimpleDropdownFromWizard");
var singleEditSponsorshipSelector = "[data-component='mySponsorships.populated.singleSponsorship.edit']";

class MySponsorshipsEditFrequencySelector extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			canEdit: props.initialValue === "M" || props.initialValue === "A" || props.initialValue === "S" || props.initialValue === "Q" || props.isDesignMode
		};
	}

	handleFrequencySelected(event) {
		if (!event || !event.currentTarget) {
			return;
		}

		var $editSponsorship = $(event.currentTarget).closest(singleEditSponsorshipSelector);
		var amount = SponsorshipHelper.calculateUpdatedTotalForMySponsorships($editSponsorship, event.currentTarget.value);

		this.updateSponsorshipAmountComponent(amount, $editSponsorship);
	}

	updateSponsorshipAmountComponent(amount, $element) {
		// update the component UI to make sure that the SD amount matches what's in the store.
		var $component = $element.find(`[data-dynamic="AmountPerGift"]`);
		if ($component) {
			var formattedAmount = ActionsHelper.formatAmount(amount, $component, /*keepDecimals*/ false);

			$component.text(formattedAmount);
		}
	}

	render() {
		return (
			<SimpleDropdownFromWizard
				{...this.props}
				disabled={!this.state.canEdit}
				thisArg={this}
				config={this.props.frequencies} /*Needs to be frequencies because the FrequencyPropertyMap is hard-coded to this*/
				onChange={this.handleFrequencySelected.bind(this)}
				wizard={window.ProjectStore.get("wizardFrequencies")}
				wizardValuesKey="allowedFrequencies"
				configKey="availableFrequencies"
				reactComponentCategory="MySponsorshipsEditFrequencySelector"
				reactComponentName="MySponsorshipsEditFrequencySelector"
				selectClassName="frequency-selector"
				optionsClassName="availableFrequency"
				selectNameAttribute="frequency"
				hideEmptyOption={true}
			/>
		);
	}
}

MySponsorshipsEditFrequencySelector.propTypes = {
	childClass: PropTypes.string,
	context: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string,
	frequencies: PropTypes.object,
	isCustomTheme: PropTypes.bool,
	isDesignMode: PropTypes.bool,
	reactComponentCategory: PropTypes.string,
	required: PropTypes.bool,
	theme: PropTypes.string
};

module.exports = MySponsorshipsEditFrequencySelector;
